import {
  FETCH_CATEGORY_GROUPS_REQUEST,
  FETCH_CATEGORY_GROUPS_SUCCESS,
  FETCH_CATEGORY_GROUPS_FAILURE,
  ADD_CATEGORY_GROUP_REQUEST,
  ADD_CATEGORY_GROUP_SUCCESS,
  ADD_CATEGORY_GROUP_FAILURE,
  UPDATE_CATEGORY_GROUP_REQUEST,
  UPDATE_CATEGORY_GROUP_SUCCESS,
  UPDATE_CATEGORY_GROUP_FAILURE,
  DELETE_CATEGORY_GROUP_REQUEST,
  DELETE_CATEGORY_GROUP_SUCCESS,
  DELETE_CATEGORY_GROUP_FAILURE,
  SET_CATEGORY_GROUP_EDIT,
  CLEAR_CATEGORY_GROUP_EDIT,
} from '../../../../types/masters/styles/categoryGroup/categoryGroupTypes';
import {
  fetchCategoryGroups,
  addCategoryGroup,
  updateCategoryGroup,
  deleteCategoryGroup,
} from '../../../../../api/masters/styles/categoryGroup/categoryGroupApi';

export const fetchCategoryGroupsAction = () => async (dispatch) => {
  dispatch({ type: FETCH_CATEGORY_GROUPS_REQUEST });
  try {
    const data = await fetchCategoryGroups();
    dispatch({ type: FETCH_CATEGORY_GROUPS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_CATEGORY_GROUPS_FAILURE, payload: error.message });
  }
};

export const addCategoryGroupAction = (categoryGroup) => async (dispatch) => {
  dispatch({ type: ADD_CATEGORY_GROUP_REQUEST });
  try {
    await addCategoryGroup(categoryGroup);
    dispatch({ type: ADD_CATEGORY_GROUP_SUCCESS });
    dispatch(fetchCategoryGroupsAction());
  } catch (error) {
    dispatch({ type: ADD_CATEGORY_GROUP_FAILURE, payload: error.message });
    throw error;
  }
};

export const updateCategoryGroupAction = ({ id, categoryGroup }) => async (dispatch) => {
  dispatch({ type: UPDATE_CATEGORY_GROUP_REQUEST });
  try {
    const data = await updateCategoryGroup(id, categoryGroup);
    dispatch({ type: UPDATE_CATEGORY_GROUP_SUCCESS, payload: data });
    dispatch(fetchCategoryGroupsAction());
  } catch (error) {
    dispatch({ type: UPDATE_CATEGORY_GROUP_FAILURE, payload: error.message });
    throw error;
  }
};

export const deleteCategoryGroupAction = (id) => async (dispatch) => {
  dispatch({ type: DELETE_CATEGORY_GROUP_REQUEST });
  try {
    await deleteCategoryGroup(id);
    dispatch({ type: DELETE_CATEGORY_GROUP_SUCCESS, payload: id });
    dispatch(fetchCategoryGroupsAction());
  } catch (error) {
    dispatch({ type: DELETE_CATEGORY_GROUP_FAILURE, payload: error.message });
    throw error;
  }
};

export const setCategoryGroupEdit = (categoryGroup) => ({
  type: SET_CATEGORY_GROUP_EDIT,
  payload: categoryGroup,
});

export const clearCategoryGroupEdit = () => ({
  type: CLEAR_CATEGORY_GROUP_EDIT,
}); 